import fetchBuildInfo from './fetchBuildInfo';

export default [
  ...fetchBuildInfo,
];
